import styled, { createGlobalStyle } from 'styled-components';
import { Select, DatePicker } from 'antd';
import { TabsWrapperProps } from 'store/ducks/Reporting/types';
import { IToken } from 'store/ducks/globalTypes';

export const EntitySelect = styled(Select)`
  width: 120px;
  margin-right: 8px;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 120px;
  margin-right: 8px;
`;

export const RisksControlsGapsFilterBar = styled.div`
  max-width: 100%;
  margin-left: 20px;
`;

export const TabsWrapper = styled.div<TabsWrapperProps>`
  .ant-tabs-tab {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }

  .ant-tabs-tab:hover {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.token.colorPrimary || '#1890ff'} !important;
  }

  .ant-tabs-tab-btn {
    color: ${(props) =>
      props.token.colorText || 'rgba(0, 0, 0, 0.88)'} !important;
  }
`;

export const risksControlsHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'middle',
  height: '56px',
  position: 'relative'
};

export const risksControlsDateHeaderStyle = {
  paddingTop: '0px'
};

export const risksControlsStartDateCellStyle = {
  borderRight: '1px solid #d9d9d9'
};

export const RisksControlsGapsTableWrapper = styled.div`
  .ant-table-thead > tr:nth-child(2) > th {
    padding: 0;
    height: 0;
    line-height: 0;
    border: 0;
  }

  .ant-table-thead > tr:nth-child(2) > th::before {
    display: none;
    content: none;
  }
`;

export const GlobalDatePickerStyle = createGlobalStyle<IToken>`
  .white-bg-datepicker .ant-picker-panel-container {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-panel {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-date-panel,
  .white-bg-datepicker .ant-picker-body {
    background: #ffffff !important;
  }
`;
